import PrevButton from '../components/buttons-navigation/button-previous';
import NextButton from '../components/buttons-navigation/button-next';

export default function PaginationNumber({currentPage, onNextClick, onBackClick}) {

    return (
        <div className="pagination-number">
            { currentPage > 1 ? <PrevButton onClick={onBackClick}>Back</PrevButton> : <PrevButton hide={true} >Back</PrevButton>}
            <div className="pagination-counter"> 
                <p>{currentPage} of 3</p>
            </div>
            <NextButton onClick={onNextClick}>Next</NextButton>
        </div>
    )
}